import React from 'react'

import { Link } from 'react-router-dom'

import { string } from 'prop-types'


function UploaderNav({ editableModelId = '' }) {
  const isActive = (pathname) => (window.location.pathname === pathname ? 'is-active' : '')
  const isModelTabActive = !!isActive('/profile/upload/model') || !!isActive(`/profile/models/${editableModelId}/edit`)
  const modelsHelpcenterPath = 'https://help.cgtrader.com/hc/en-us/sections/360004404498-Publishing-models'

  return (
    <div className="card uploader-nav">
      <ul className="nav-tabs--fatter-font">
        <li
          className={`tab ${isActive('/profile/upload/model')} ${isActive(`/profile/models/${editableModelId}/edit`)}`}
        >
          <Link to="/profile/upload/model">Model Upload</Link>
        </li>
        <li className={`tab ${isActive('/profile/upload/batch')}`}>
          <Link to="/profile/upload/batch">Batch Upload</Link>
        </li>
        <li className={`tab ${isActive('/profile/upload/tutorial')}`}>
          <Link to="/profile/upload/tutorial">New Tutorial</Link>
        </li>
        {isModelTabActive && (
          <li className="tab is-right">
            <a href={modelsHelpcenterPath} target="_blank" rel="noopener noreferrer">
              Visit Helpcenter
            </a>
          </li>
        )}
      </ul>
    </div>
  )
}

UploaderNav.propTypes = {
  editableModelId: string,
}

export default UploaderNav
